<header>
    <a routerLink="dashboard">
        <img src="./assets/logo_inverted.svg" />
    </a>

    <div class="menu">
        <a routerLinkActive="active-link" routerLink="dashboard" i18n="@@Dashboard">Dashboard</a>
        <a routerLinkActive="active-link" routerLink="practices" i18n="@@Practices">Practices</a>
        <!-- <a routerLinkActive="active-link" routerLink="quality" i18n="@@Quality">Quality</a> -->
    </div>

    <button mat-button [matMenuTriggerFor]="menu">
        <ng-container i18n="@@Account">Account</ng-container><mat-icon>arrow_drop_down</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
        <div *ngIf="authService.userInfo$ | async as userInfo">
            <button mat-menu-item routerLink="profile">
                <mat-icon>account_circle</mat-icon>
                <span i18n="@@Profile">Profile</span>
            </button>
            <button mat-menu-item (click)="authService.login()" *ngIf="!userInfo.isLoggedIn">
                <mat-icon>expand_less</mat-icon>
                <span i18n="@@LogIn">Log in</span>
            </button>
            <button mat-menu-item (click)="authService.logout()" *ngIf="userInfo.isLoggedIn">
                <mat-icon>exit_to_app</mat-icon>
                <span i18n="@@LogOut">Log out</span>
            </button>
            <div style="font-size: x-small; text-align: center; margin-top: 12px"><span i18n="@@version">version</span> {{ version }}</div>
        </div>
    </mat-menu>
</header>

<div class="wrapper">
    <router-outlet></router-outlet>
</div>
